import React, { Component } from 'react';
import './TVIntegrationSlide.scss';
import { getUsers } from '../../actions/UsersActions';
import { connect } from 'react-redux';
import { Avatar } from '@material-ui/core';

class TVIntegrationSlide extends Component {
  // largest and smallest sizes for circles
  largest = 0.25;
  smallest = 0.14;
  timeout = null;


  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  getPercentagesForUserPictures() {
    const { users } = this.props;

    console.log(users);

    const slope = (this.largest - this.smallest) / (users[0].added - users[users.length - 1].added);
    const yIntercept = this.largest - slope * users[0].added;

    let size1, size2 = 0;
    if (users[1]) size1 = slope * users[1].added + yIntercept;
    if (users[2]) size2 = slope * users[2].added + yIntercept;

    return { size1, size2 };
  }

  renderTimeFrame() {
    switch (this.props.timeFrame) {
      case 'week': return 'This Week';
      case 'today': return 'Today';
      case 'month': return 'This Month';
      case 'all': return '';
    }
  }

  renderUsers() {
    const { users } = this.props;
    const height = window.innerHeight - 164 - 76; // subtract header and footer heights
    let width = window.innerWidth;
    // 2.4 is about the max ratio before we need to cut off;
    if (width / height > 2.4) {
      width = height * 2.4;
    }

    if (users && users.length && users[0].user) {
      const { size1, size2 } = this.getPercentagesForUserPictures();
      return (
        <div className="avatar-holder">
          <div style={{ height: height / 2, width: width }} className="top-half">
            {users[0] && users[0].user &&
              <div style={{ height: this.largest * width - 50, width: width * this.largest - 50 }} className="user-wrapper-1 user-wrapper">
                <Avatar className="user-icon-integration" alt="avatar" src={users[0].user.photoURL} />
                <div className="user-code-info">
                  <span className="user-name">{users[0].user.displayName}</span>
                  <span className="added">+{users[0].added}</span>
                  <span className="removed">-{users[0].removed}</span>
                </div>
              </div>
            }
            {users[1] && users[1].user &&
              <div style={{ height: size1 * width - 50, width: width * size1 - 50 }} className="user-wrapper-2 user-wrapper">
                <Avatar className="user-icon-integration" alt="avatar" src={users[1].user.photoURL} />
                <div className="user-code-info">
                  <span className="user-name">{users[1].user.displayName}</span>
                  <span className="added">+{users[1].added}</span>
                  <span className="removed">-{users[1].removed}</span>
                </div>
              </div>
            }
          </div>
          <div style={{ height: height / 2, width: width }} className="bottom-half">
            {users[2] && users[2].user &&
              <div style={{ height: size2 * width - 50, width: width * size2 - 50 }} className="user-wrapper-3 user-wrapper">
                <Avatar className="user-icon-integration" alt="avatar" src={users[2].user.photoURL} />
                <div className="user-code-info">
                  <span className="user-name">{users[2].user.displayName}</span>
                  <span className="added">+{users[2].added}</span>
                  <span className="removed">-{users[2].removed}</span>
                </div>
              </div>
            }
            {users[3] && users[3].user &&
              <div style={{ height: this.smallest * width - 50, width: width * this.smallest - 50 }} className="user-wrapper-4 user-wrapper">
                <Avatar className="user-icon-integration" alt="avatar" src={users[3].user.photoURL} />
                <div className="user-code-info">
                  <span className="user-name">{users[3].user.displayName}</span>
                  <span className="added">+{users[3].added}</span>
                  <span className="removed">-{users[3].removed}</span>
                </div>
              </div>
            }
          </div>
        </div>
      );
    } else {
      this.props.getUsers();
      return null;
    }
  }

  render() {
    // const { visible } = this.props;
    let visible = true;
    if (!visible) return null;

    const className = visible ? 'tv-alert-wrapper visible' : 'tv-alert-wrapper';
    return (
      <div className={className}>
        <span className="title-text">
          <span className="bolder-title">Prism Progress </span>
          Lines of Code Pushed {this.renderTimeFrame()}
        </span>
        {this.renderUsers()}
      </div>
    );
  }
}

const mapStateToProps = ({ metricsStore, usersStore, tvModeStore }) => {
  const { userMetrics } = metricsStore;
  const { users } = usersStore;
  const { timeFrame } = tvModeStore;

  let usersArray = userMetrics.map((metric) => {
    let metricObj = { ...metric };
    metricObj.user = users.filter((user) => user._id === metric.pusher)[0];
    return metricObj;
  });
  usersArray = usersArray.sort((a, b) => b.added - a.added);
  return { users: usersArray, timeFrame };
};

export default connect(mapStateToProps, { getUsers })(TVIntegrationSlide);


// WEBPACK FOOTER //
// ./src/screens/tv/TVIntegrationSlide.js